import React, { useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Bars, MenuButton } from "./styles";

interface IOpenNavButtonProps {
  open: boolean;
  toggleHandler: () => void;
}

const OpenNavButon: React.FC<IOpenNavButtonProps> = ({
    open,
    toggleHandler
}) => {
    const history = useHistory();

    useEffect(() => {
    // eslint-ignore-next-line
        history.listen((location) => {
            toggleHandler();
        });
    }, [history, toggleHandler]);

    return (
        <MenuButton onClick={ () => toggleHandler() } open={ open }>
            <Bars open={ open } />
        </MenuButton>
    );
};

export default OpenNavButon;
